import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home_hs'
import New from "@/pages/New"
import Chart from '@/pages/MarketChart'
import Login from '@/pages/LoginByIcode'
import Register from '@/pages/Register'
import VCode from '@/pages/VPhone'
import PasswordSet from '@/pages/PasswordSet'
import My from "@/pages/My.vue";
import Index from "@/pages/Index_hs.vue";
import News from '@/pages/News.vue';
import Market from "@/pages/Market.vue";
import TradeView from '@/pages/TradeView.vue'
import BuyCNc from '@/pages/BuyCNc'
import TiXian from '@/pages/TiXian'
import Help from '@/pages/Kefu'
import TixianRecord from '@/pages/TixianRecord'
import RechargeRecord from '@/pages/RechargeRecord'
import Transactions from '@/pages/Transactions'
import ResetPass from '@/pages/ResetPass'
import BetRecords from '@/pages/BetRecords'
import OpenRecords from '@/pages/OpenRecords'
import AddBank from '@/pages/AddBank'
import SetPass1 from '@/pages/SetPass1'
import About from '@/pages/About'
import Kefu  from '@/pages/Service'
import Auth from '@/pages/Auth'  
import Wallet from '@/pages/Wallet'
import TixianMode from '@/pages/TixianMode'

Vue.use(Router)

export default new Router({
    routes: [{
            path: "/",
            redirect: '/home/index'
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            children: [{
                    path: 'index',
                    name: 'index',
                    component: Index
                },
                {
                    path: 'market',
                    name: 'market',
                    component: Market,
                },

                {
                    path: "tradeview/:c",
                    name: 'tradeview',
                    component: TradeView,
                },
                {
                    path: 'help',
                    name: 'help',
                    component: Help,
                },
                {
                    path: 'about',
                    name: 'about',
                    component: About,
                },
                {
                    path: 'news',
                    name: 'news',
                    component: News,
                },
                {
                    name: 'my',
                    path: "my",
                    component: My
                },
            ]
        },
        {
            path:'/kefu',
            name:'kefu',
            component: Kefu,
        },
        { path:'/auth',
          name:'auth',
          component:Auth

        },
        
        {
            path: '/chart',
            name: "chart",
            component: Chart
        },
        {
            path: '/new',
            name: "new",
            component: New
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/addbank',
            name: "addbank",
            component: AddBank
        },
        {
            path: '/wallet',
            name: "wallet",
            component: Wallet
        },
        {
            path: '/tixianmode',
            name: "tixianmode",
            component: TixianMode
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/vcode',
            name: 'vcode',
            component: VCode
        },
        {
            path: "/tixianpass",
            name: "tixianpass",
            component: SetPass1
        },
        {
            path: '/passwordset',
            name: 'passwordset',
            component: PasswordSet

        },
        {
            path: '/one-trade',
            name: 'buycnc',
            component: BuyCNc
        },
        {
            path: '/tixian',
            name: 'tixian',
            component: TiXian
        },
        {
            path: '/tixianrecords',
            name: '/tixianrecords',
            component: TixianRecord
        },
        {
            path: '/openrecords',
            name: '/openrecords',
            component: OpenRecords
        },
        {
            path: '/rechargerecords',
            name: 'rechargerecords',
            component: RechargeRecord
        },
        {
            path: '/betrecords',
            name: 'betrecords',
            component: BetRecords
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: Transactions
        },
        {
            path: '/resetpass',
            name: 'resetpass',
            component: ResetPass
        }

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js